import React from 'react'

import { Tooltip } from '@mui/material'
import { Link } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { useUser } from 'hooks/useUser'

type AuditUserProps = {
  userId: number
}

const AuditUser = ({ userId }: AuditUserProps) => {
  const { isLoading, data: user } = useUser(userId)

  if (isLoading || !user) return `User ID: ${userId}`

  const title = [user.first_name, user.last_name].filter(Boolean).join(' ')

  return (
    <Link to={UrlProvider.getUrl('user', { id: userId })}>
      <Tooltip title={title}>
        <div>{user.email}</div>
      </Tooltip>
    </Link>
  )
}

export default AuditUser
